import(/* webpackMode: "eager" */ "/tmp/build_ed8c862a/src/app/search/page.jsx");
